import { Autocomplete, Box, Button, Menu, MenuItem, TextField, Tooltip, Typography, Divider, Paper, Modal, ListItemText, IconButton } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { CommonDeleteButton, CommonEditButton, CommonPatientCard, CommonPatientDetails, CommonPopUp, ConsultantPatientCard, DeletePopup, ToolsFieldWithMic } from '../../../../../Components/Common Components/CommonComponents'
import MUIRichTextEditor from 'mui-rte'
import { withTranslation } from 'react-i18next'
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../../Utility/API/Serviceurls'
import { getCachevalue, localGetItem } from '../../../../../Utility/Services/CacheProviderService'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Colors } from '../../../../../Styles/Colors'
import { CheckAccessFunc, ContentInTooltip } from '../../../../../Components/CommonFunctions/CommonFunctions'
import Loader from '../../../../../Components/Loader';
import MicIcon from '@mui/icons-material/Mic';
import { grey } from '@mui/material/colors';
import VoiceToText from '../../../../../Components/Common Components/VoiceToText';
import { ImagePaths } from '../../../../../Utility/ImagePaths';
import { DateTime } from 'luxon'
import apiQueueService from '../../../../../Utility/Services/ApiQueueService'

class IpNurseNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nurseNotesText: "",
      patientData: {},
      nurseText: "",
      text: "",
      clinicalNurseNotesData: [],
      delSelectedId: '',
      selectedEditId: "",
      delSelectedId: "",
      deletePopup: false,
      nurseNotesHistory: [],
      templateList: [],
      selectedTemplateName: null,
      openPopupAddNew: false,
      templateName: '',
      tempType: '',
      template: null,
      templateData: [],
      isHistoryClicked: false,
      postCall: false,
      withOutAppointment: {},
      listenPopUp: false,
      clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),
      date_time: new Date(),
      isDoctor: JSON.parse(localGetItem('loggedInUserInfo'))?.is_doctor === true ? true : false,
      NurseList: [],
      nurseName: null,
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  componentDidMount() {
    let patientDatas = getCachevalue("IppatientData")
    let patients = JSON.parse(patientDatas)
    let appointmentDetail = getCachevalue("withoutAppointment");
    let details = JSON.parse(appointmentDetail);
    this.getNurseList().then(() => {
      if (details?.patient_id === patients?.patient_id) {
        this.setState({
          withOutAppointment: details,
          patientData: patients
        }, () => {
          this.getNurseNotesPatientData()
          this.getNurseNotesData()
          this.getExamTemplateData()
        })
      } else {
        this.setState({
          patientData: patients
        }, () => {
          this.getNurseNotesPatientData()
          this.getNurseNotesData()
          this.getExamTemplateData()
        })
      }
    });
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  onClearHandler = () => {
    if (this.state.NurseList?.length && localGetItem("NurseId")) {
      let nurseId = JSON.parse(localGetItem("NurseId"))
      let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
      this.setState({
        nurseName: nurseData || null
      })
    }
    this.setState((prevState) => ({
      nurseNotesText: "",
      isEdit: this.props.is_From_IpNotes ? false : prevState.isEdit,
      selectedEditId: this.props.is_From_IpNotes ? "" : prevState.selectedEditId,
      date_time: new Date(),
    }));
  }

  setEditedData = (data, value) => {
    this.setState({
      nurseNotesText: value
    })
  }

  getNurseNotesPatientData = () => {
    let admission_id = this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id;
    let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.FO_PATIENT_DETAILS : Serviceurls.FO_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}`;
    if (this.props.is_From_IpNotes && this.state.clinic_id) {
      url = `${url}&clinic_id=${this.state.clinic_id}`
    }
    try {
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              nurse_attender_name: response.data.data[0].attender_name,
              nurse_attender_mobile: response.data.data[0].attender_mobile,
              nurse_doctor_name: response.data.data[0].doctor_name,
              nurse_doctor_id: response.data.data[0].doctor_id,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getNurseNotesHistoryData = (id) => {
    try {
      let url = Serviceurls.FO_IP_HISTORY + `?condition=notesnursenotes&row_id=${id}`;
      if (this.state.clinic_id) {
        url = `${url}&clinic_id=${this.state.clinic_id}`
      }
      RestAPIService.getAll(url).
        then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              nurseNotesHistory: response.data.data,
              isHistoryClicked: true
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getNurseNotesData = () => {
    let admission_id = this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id;
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    let url = `${Serviceurls.FO_IP_CLINICAL_NURSE_NOTES}?ip_admission_id=${admission_id}`;
    if (this.props.is_From_IpNotes && UserData?.doctor_id) {
      url = `${url}&doctor_id=${UserData?.doctor_id}`
    }
    try {
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === 'success') {
            const mappedNurseNotesData = response.data.data.map(item => {
              let nurse_name = "-";
              if (item.nurse_profile_id && this.state.NurseList?.length > 0) {
                const foundNurse = this.state.NurseList.find(
                  nurse => nurse.staff_id === item.nurse_profile_id
                );
                nurse_name = foundNurse ? foundNurse.nurse : "-";
              }

              return {
                ...item,
                nurse_name: nurse_name
              };
            });
            this.setState({
              clinicalNurseNotesData: mappedNurseNotesData
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  clearEditor = () => {
    this.setState({
      nurseNotesText: "",
      nurseName: null,
      isEdit: false,
    }, () => {
      if (this.state.NurseList?.length && localGetItem("NurseId")) {
        let nurseId = JSON.parse(localGetItem("NurseId"))
        let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
        this.setState({
          nurseName: nurseData || null
        })
      }
    })
  }

  postIpNurseNotesData = (textEditorValue, clearFunc, nurseDate) => {
    try {
      let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
      let clinicId = localGetItem("SelectedDoctorClinicId") ? localGetItem("SelectedDoctorClinicId") : localGetItem("clinicId") ? localGetItem("clinicId") : null
      if (!this.state.nurseName || this.state.nurseName === null) {
        this.errorMessage("Please select Nurse Name")
        return
      }
      let data = {
        "ip_admission_id": this.state.patientData?.id,
        "nurse_notes": textEditorValue,
        "clinic_id": +clinicId,
        "date_time": DateTime.fromJSDate(nurseDate ? new Date(nurseDate) : new Date()).toFormat("yyyy-MM-dd HH:mm:ss"),
        'nurse_profile_id': this.state?.nurseName?.staff_id || null,
      }
      if (this.state.isEdit) {
        data["notes_id"] = this.state.selectedEditId
      }
      this.LoaderFunction(true)
      RestAPIService.create(data, Serviceurls.FO_IP_CLINICAL_NURSE_NOTES)
        .then((response) => {
          if (response.data.status === 'success') {
            this.onClearHandler()
            this.getNurseNotesData()
            clearFunc();
            this.setState({
              isEdit: false, postCall: false, templateName: "",
              selectedTemplateName: null,
            })
            this.LoaderFunction(false)
            this.successMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getNurseList = () => {
    return new Promise((resolve, reject) => {
      try {
        RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + `?clinic_id=${this.state.clinic_id}`)
          .then((response) => {
            if (response.data.status === "success") {
              this.setState({
                NurseList: response.data.data
              }, () => {
                resolve(response.data.data);
                if (response?.data?.data?.length && localGetItem("NurseId") && !this.state.nurseName) {
                  let nurseId = JSON.parse(localGetItem("NurseId"))
                  let nurseData = response.data.data.find((item) => item.staff_id === nurseId)
                  this.setState({
                    nurseName: nurseData || null
                  })
                }

              });
            }
          }).catch((error) => {
            reject(error);
            this.errorMessage(error?.response?.data?.message || error.message);
          })
      } catch (error) {
        reject(error);
        this.errorMessage(error.message);
      }
    });
  }

  postNewTemplateData = () => {
    try {
      if (!this.state.templateName) {
        this.errorMessage("Please enter template name");
        return;
      }
      if (!this.state.nurseNotesText || this.state.nurseNotesText.trim() === "") {
        this.errorMessage("Nurse notes content is empty");
        return;
      }
      if (!this.state?.nurseName?.staff_id) {
        this.errorMessage("Select Nurse Name");
        return;
      }
      let data = {};
      if (this.state.tempType === "rename") {
        data = {
          id: this.state.selectedTemplateName?.id,
          nurse_profile_id: this.state?.nurseName?.staff_id || null,
          template_name: this.state.templateName?.replace(/\s+/g, " ").trim(),
        };
      } else {
        data = {
          nurse_profile_id: this.state?.nurseName?.staff_id || null,
          template_content: this.state.nurseNotesText,
          template_name: this.state.templateName?.replace(/\s+/g, " ").trim(),
          template_applied_for: this.state.patientData.ip_number ? "ip" : "op"
        };
      }

      this.setState({ templateLoad: true });

      const apiCall = this.state.tempType === "rename"
        ? RestAPIService.updateWithOutId(data, Serviceurls.IP_NURSENOTES_TEMPLATE)
        : RestAPIService.create(data, Serviceurls.IP_NURSENOTES_TEMPLATE);
      apiCall
        .then((response) => {
          if (response?.data?.status === "success") {
            this.successMessage(response.data.message);

            this.setState({
              templateLoad: false,
              openPopupAddNew: false,
              templateName: "",
              selectedTemplateName: null,
              isEdit: false
            });

            this.getExamTemplateData();
          }
        })
        .catch((error) => {
          this.setState({ templateLoad: false });

          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message);
          } else {
            this.errorMessage(error.message);
          }
        });

    } catch (error) {
      this.setState({ templateLoad: false });
      this.errorMessage(error.message);
    }
  };

  deleteExamTemplateData = (id) => {
    try {
      let data = {
        "id": id,
        "nurse_profile_id": this.state?.nurseName?.staff_id || null,

      }
      this.setState({ templateLoad: true });
      RestAPIService.delete(Serviceurls.IP_NURSENOTES_TEMPLATE, data)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.successMessage(response.data.message);
            this.setState({
              templateLoad: false,
              selectedTemplateName: null,
              nurseNotesText: "",
            });
            this.getExamTemplateData();
          }
        })
        .catch((error) => {
          this.setState({ templateLoad: false });
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message);
          } else {
            this.errorMessage(error.message);
          }
        });
    } catch (error) {
      this.setState({ templateLoad: false });
      this.errorMessage(error.message);
    }
  };

  onEditHandler = (row) => {
    try {
      const existingNurse = this.state.NurseList.find(
        nurse => nurse.staff_id === row.nurse_profile_id
      );
      this.setState({
        isEdit: false,
        selectedEditId: "",
        nurseNotesText: ""
      }, () => {
        setTimeout(() => {
          this.setState({
            isEdit: true,
            nurseNotesText: row?.nurse_notes || "",
            selectedEditId: row?.id,
            date_time: row?.date_time ? row?.date_time : null,
            nurseName: existingNurse || null
          });
        }, 0);
      });
    } catch (error) {
      this.errorMessage(error.message);
    }
  };

  popupClose = () => {
    this.setState({ deletePopup: false })
  }

  onDeleteHandler = (value) => {
    if (!this.state.isEdit) {
      this.setState({
        deletePopup: true,
        rowValue: value?.row,
        delSelectedId: value?.row?.id
      })
    }
  }

  deleteNurseNotesData = () => {
    try {
      RestAPIService.delete(Serviceurls.FO_IP_CLINICAL_NURSE_NOTES + '?notes_id=' + this.state.delSelectedId)
        .then((response) => {
          if (response.data.status === 'success') {
            this.successMessage(response.data.message)
            this.setState({ deletePopup: false })
            this.getNurseNotesData()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  MenuItem = (data) => {
    const { t } = this.props
    const list = [
      { value: "History", label: t("History") },
    ]
    return (
      <div>
        <Tooltip title={t("More")} placement='top' arrow>
          <Button
            disabled={this.state.withOutAppointment?.is_ip}
            className='eMed_vital_more'
            onClick={(e) => {
              this.setState({
                anchorEl: e.currentTarget,
                selectedRow: data.id,
                isSelected: true
              })
            }}
          >
            <MoreVertIcon />
          </Button>
        </Tooltip>
        {(this.state.isSelected && this.state.selectedRow == data.id) ?
          <Menu
            anchorEl={this.state.anchorEl}
            open={Boolean(this.state.anchorEl)}
            onClose={() => {
              this.setState({ anchorEl: null, })
            }}>
            <MenuItem onClick={() => { this.setState({ anchorEl: null }, () => { this.getNurseNotesHistoryData(data?.row?.id) }) }}>
              {t("History")}
            </MenuItem>
          </Menu> : null}
      </div>
    )
  }

  getNurseHistory = () => {
    const { t } = this.props
    this.state.nurseNotesHistory.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: "modified_by_to", headerName: "Modified By", flex: 0.33,
        renderCell: (params) => (<Box component={'div'}>{params?.row?.modified_by_to ? params?.row?.modified_by_to : '-'}</Box>)
      },
      {
        field: "modified_date", headerName: "Modified Date And Time", flex: 0.33, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.modified_date ? params?.row?.modified_date : '-'}</Box>)
      },
      {
        field: "nurse_notes_from", headerName: "Previous Nurse Notes", flex: 0.33,
        renderCell: (params) => {
          const rawText = params?.row?.nurse_notes_from || "-"; // Handle empty case
          const htmlToPlainText = (str) => {
            const temp = document.createElement("div");
            temp.innerHTML = str;
            return temp.textContent || temp.innerText || "";
          };
          const plainText = htmlToPlainText(rawText);
          const isLongText = plainText.length > 25;

          return (
            <Box component={"div"}>
              {isLongText ? (
                <Tooltip placement="right" title={<div dangerouslySetInnerHTML={{ __html: rawText }} />} arrow>
                  <span>{plainText.slice(0, 25) + "..."}</span>
                </Tooltip>
              ) : (
                <span>{plainText}</span>)}
            </Box>
          );
        },
      }
    ]
    return (
      <Box component={'div'} className='eMed_history_nurse_grid'>
        <DataGrid
          rows={this.state.nurseNotesHistory}
          columns={columns}
          getRowId={(row) => row.sno}
          density='compact'
          hideFooter
          components={{
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata'>
                {t("NoRecordsFound")}
              </Box>
            )
          }}
        />
      </Box>
    )
  }

  renderLeftContent = () => {
    const { t } = this.props
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    const columns = [
      {
        field: "date_time", headerName: "Date & Time", flex: 0.23, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.date_time ? params?.row?.date_time.length > 20 ?
          <Tooltip title={params?.row?.date_time} placement='top' arrow><div>{params?.row?.date_time.slice(0, 20) + '...'}</div></Tooltip> : params?.row?.date_time : "-"}</Box>)
      },
      {
        field: "nurse_notes", headerName: "Nurse Notes", flex: 0.37,
        renderCell: (params) => {
          const rawHTML = params?.row?.nurse_notes || "-"; // Handle empty cases
          const htmlToPlainText = (str) => {
            const temp = document.createElement("div");
            temp.innerHTML = str;
            return temp.textContent || temp.innerText || "";
          };

          const plainText = htmlToPlainText(rawHTML);
          const isLongText = plainText.length > 20;

          return (
            <Box component={"div"}>
              {isLongText ? (
                <Tooltip placement="right" title={<div dangerouslySetInnerHTML={{ __html: rawHTML }} />} arrow>
                  <span>{plainText.slice(0, 20) + "..."}</span>
                </Tooltip>
              ) : (
                <span>{plainText}</span>
              )}
            </Box>
          );
        },
      },
      {
        field: "modified_by", headerName: "Modified By", flex: 0.15,
        renderCell: (params) => (<Box component={'div'}>{params?.row?.modified_by ? params?.row?.modified_by : '-'}</Box>)
      },
      {
        field: 'nurse_name', headerName: 'Nurse Name', flex: 0.25,
        renderCell: (params) => {
          let nurseName = params?.row?.nurse_name;
          return (
            <Box>
              {nurseName ? nurseName.length > 15 ?
                <Tooltip placement="top" title={nurseName}>
                  <Typography>{nurseName.slice(0, 15) + '...'}</Typography>
                </Tooltip> :
                <Typography>{nurseName}</Typography> : '-'}
            </Box>
          )
        }
      },
      {
        field: "action", headerName: "Action", flex: 0.2, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingRight={'0.5vw'}>
          {this.props.is_From_IpNotes ?
            <Tooltip title="View" placement="top" arrow>
              <Button emed_tid={this.props.testID} disabled={!CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Nurse Notes", "SubTab").editAccess} className="eMed_Edit_btn eMed_usrconf_btn" size='small'>
                <img src={ImagePaths.LabViewButton.default} style={{ height: '1.5dvw', width: '1.5dvw' }} alt='View'
                  onClick={() => { this.onEditHandler(params?.row) }} />
              </Button>
            </Tooltip> :
            <CommonEditButton disable={this.state.withOutAppointment?.is_ip || !CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Nurse Notes", "SubTab").editAccess} size='1.5vw' onClick={this.onEditHandler.bind(this, params?.row)} />}
          {this.props.is_From_IpNotes ? null : <CommonDeleteButton disable={this.state.withOutAppointment?.is_ip || this.state.isEdit || !CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Nurse Notes", "SubTab").editAccess} size='1.5vw' onClick={this.onDeleteHandler.bind(this, params)} />}
          {this.props.is_From_IpNotes ? null : this.MenuItem(params)}
        </Box>)
      }
    ]
    return (
      <Box component={'div'} className='eMed_nur_notes_left_card'>
        <DataGrid
          className='eMed_nur_notes_grid'
          rows={this.state.clinicalNurseNotesData}
          columns={columns}
          getRowId={(row) => row?.id}
          density='compact'
          components={{
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata'>
                {t("NoRecordsFound")}
              </Box>
            )
          }}
          disableSelectionOnClick
          hideFooter
        />
      </Box>
    )
  }

  historyPopUpClose() {
    this.setState({
      isHistoryClicked: false,
      nurseNotesHistory: []
    })
  }

  voiceToTextgetter = (textStorage) => {
    if (textStorage != "") {
      let states = this.state
      if (states.nurseNotesText?.length) {
        let data = (states.nurseNotesText)
        //  states.nurseNotesText = `{"blocks":[{"key":"1cu3s","text":"${data.blocks[0].text + " " + textStorage}" ,"type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`
        states.nurseNotesText = data + " " + textStorage
        this.setState({
          states
        })
      }
      else {
        // states.nurseNotesText = `{"blocks":[{"key":"1cu3s","text":"${textStorage}" ,"type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`
        states.nurseNotesText = textStorage
        this.setState({
          states
        })
      }
    }
    this.setState({
      listenPopUp: false,
    })
  }

  renderRightContent = () => {
    const states = this.state;
    const currentDate = new Date();
    const admissionDate = states?.patientData?.admitted_date ? new Date(states.patientData?.admitted_date) : states?.patientData?.admission_date
      ? new Date(states.patientData?.admission_date) : currentDate;
    const dischargeDate = states.patientData?.discharge_date && (new Date(states.patientData?.discharge_date) <= currentDate) ?
      new Date(states.patientData?.discharge_date) : currentDate;

    return (
      <Box component={'div'} className='eMed_nur_notes_right_card' sx={{ height: "0vh", marginTop: "-1.4vh" }}>
        <ToolsFieldWithMic
          key={this.state.selectedEditId || "new"}
          Title={"Nurse Notes"}
          EditorRef={this.state.nurseNotesText}
          EditorDisable={false}
          minHeight={"46vh"}
          EditorHeight={"46vh"}
          overallHeight={"64dvh"}
          clearEditorText={this.clearEditor}
          isFrom="NurseNotes"
          date_time={this.state.date_time}
          admissionDate={admissionDate}
          dischargeDate={dischargeDate}
          disableSave={!CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Nurse Notes", "SubTab").editAccess}
          handlePostdata={this.postIpNurseNotesData.bind(this)}
          setEditedData={this.setEditedData}
        />
      </Box>
    )
  }
  getExamTemplateData = () => {
    try {
      const query = `?template_applied_for=${this.state.patientData.ip_number ? "ip" : "op"}${this.state.isDoctor ? `&clinic_id=${this.state.clinic_id}` : ""}`;
      return apiQueueService.enqueue(() =>
        RestAPIService.getAll(Serviceurls.IP_NURSENOTES_TEMPLATE + query)
      )
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              templateList: response.data.data
            })
          }
          return response;
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
          throw error;
        })
    } catch (error) {
      this.errorMessage(error.message)
      return Promise.reject(error);
    }
  }
  renderTemplatePopup = () => {
    try {
      return (
        <Box component={'div'}>
          <Modal open={this.state.openPopupAddNew}>
            <Box component={'div'} className='eMed_Doc_Notes_Prescrip_Fav_Pop_Up'>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} p={'0.5vw'} alignItems={'center'}>
                <Typography fontSize={'0.9vw'} fontWeight={600}>
                  {this.state.tempType === 'Add' ? 'Add New Template' : this.state.tempType === 'rename' ? 'Rename Template' : 'Delete Template'}
                </Typography>
                <Button className='Common_Btn_Min_Width'
                  onClick={() => this.setState({ openPopupAddNew: false }, () => this.setState({ templateName: '' }))}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1.1vw'} width={'1.1vw'} />
                </Button>
              </Box>
              <Box component={'div'} ml={'2.5vw'}>
                <TextField
                  size='small'
                  sx={{ width: '20vw' }}
                  label='Enter Template Name'
                  value={this.state.templateName}
                  onChange={(e) => this.setState({ templateName: e.target.value })}
                />
              </Box>
              <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
                <Button
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
                  variant='outlined'
                  onClick={() => this.setState({ templateName: '' })}
                >Clear</Button>
                <Button
                  sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                  variant='contained'
                  onClick={() => this.postNewTemplateData()}
                >{this.state.tempType === 'rename' ? 'Update' : 'Add'}</Button>
              </Box>
            </Box>
          </Modal>

        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  render() {
    const { t } = this.props
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    let attenderDetails = {
      lineOne: t("AttenderName"),
      lineTwo: `${this.state.nurse_attender_name ? this.state.nurse_attender_name : " -"}`,
      lineFour: t('ContactNumber'),
      LineFive: `${this.state.nurse_attender_mobile ? this.state.nurse_attender_mobile : "-"}`
    }
    let doctorDetails = {
      lineOne: t("ConsultantName"),
      lineTwo: `${this.state.nurse_doctor_name ? this.state.nurse_doctor_name : " -"}`
    }

    return (
      <Box component={'div'} className='eMed_nur_note_container'>
        <Box display={'flex'} >
          <Box className='eMed_nur_notes_details eMed_patient_nur_notes'>
            <CommonPatientDetails data={this.state.patientData} showDetailed={true} />
          </Box>
          <CommonPatientCard details={attenderDetails} showDetailed={true} />
          <ConsultantPatientCard name={doctorDetails} width={this.props.is_From_IpNotes ? "20dvw" : "20dvw"} />
          <Autocomplete
            size='small'
            sx={{ margin: '0.2vw', mt: '0.6vw' }}
            options={this.state.NurseList || []}
            getOptionLabel={(option) => option.nurse}
            value={this.state.nurseName}
            onChange={(event, newValue) => {
              this.setState(() => ({
                nurseName: newValue,
              })
              )
            }}
            renderInput={(params) => (
              <TextField
                margintop="1vw"
                sx={{ width: "11dvw" }}
                {...params}
                label={t("Nurse Name *")}
              />
            )}
          />
          <Autocomplete
            clearIcon
            size="small"
            sx={{ width: "13vw", margin: "0.2vw", mt: '0.6vw' }}
            options={this.state.templateList}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option?.template_name
            }
            disabled={!this.state?.nurseName?.staff_id}
            value={this.state.selectedTemplateName}
            onChange={(e, value) => {
              this.setState((prev) => ({
                selectedTemplateName: value,
                nurseNotesText: prev.nurseNotesText
                  ? prev.nurseNotesText + " " + (value?.template_content || "")
                  : value?.template_content || "",
              }));
            }}

            renderOption={(props, option) => (
              <li {...props}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <ListItemText
                    primary={
                      option?.template_name?.length > 20 ? (
                        <Tooltip placement="left" title={option.template_name} arrow>
                          <div>{option.template_name.slice(0, 10) + "..."}</div>
                        </Tooltip>
                      ) : (
                        option?.template_name
                      )
                    }
                  />

                  <Tooltip title="Delete" arrow>
                    <IconButton
                      size="small"
                      color='error'
                      onClick={(e) => {
                        e.stopPropagation();
                        this.deleteExamTemplateData(option?.id);
                      }}
                    >
                      <DeleteIcon sx={{ fontSize: "1.1vw" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </li>
            )}

            renderInput={(params) => (
              <TextField sx={{ margintop: "1vw" }} {...params} label="Select Template" />
            )}

            PaperComponent={({ children }) => (
              <Paper sx={{ maxHeight: "25vw", overflow: "scroll" }}>
                {children}
                <Divider />

                <Button
                  color="primary"
                  fullWidth
                  sx={{ justifyContent: "flex-start", pl: 2, textTransform: "capitalize" }}
                  onMouseDown={() => {
                    this.setState({
                      openPopupAddNew: true,
                      tempType: "Add",
                      nurseNotesText: this.state.nurseNotesText,
                    });
                  }}
                >
                  Add Template
                </Button>

                {this.state.selectedTemplateName && (
                  <>
                    <Button
                      color="primary"
                      fullWidth
                      sx={{
                        justifyContent: "flex-start",
                        pl: 2,
                        textTransform: "capitalize",
                      }}
                      onMouseDown={() => {
                        this.setState({
                          openPopupAddNew: true,
                          tempType: "rename",
                          templateName:
                            this.state.selectedTemplateName?.template_name,
                        });
                      }}
                    >
                      Rename
                    </Button>
                  </>
                )}
              </Paper>
            )}
          />
        </Box>
        {this.renderTemplatePopup()}
        <Box component={'div'} className='eMed_nur_note_card'>
          <Box component={'div'} className='eMed_nur_note_left'>
            {this.renderLeftContent()}
          </Box>
          <Box component={'div'} className='eMed_nur_note_right'>
            {this.renderRightContent()}
          </Box>
        </Box>
        {this.state.deletePopup ? <DeletePopup
          DeletTitle={`${t("deleteMsg")} ?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.deleteNurseNotesData.bind(this)}
        /> : null}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {(this.state.isHistoryClicked) ?
          <CommonPopUp width={"56vw"}
            backgroundColor={Colors.white}
            popUpClose={this.historyPopUpClose.bind(this)}
            title={t("History")}
            component={this.getNurseHistory.bind(this, this.state.nurseNotesHistory)} />
          : null
        }
        <Loader loaderOpen={this.state.isLoader} />
        {(this.state.listenPopUp) ?
          <VoiceToText
            voiceTextConverter={this.voiceToTextgetter.bind(this)}
            listenPopUp={this.state.listenPopUp}
          />
          : null}
      </Box>
    )
  }
}

export default withTranslation()(IpNurseNotes)
